var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 2.34375H14.0475L13.6666 1.20164C13.4268 0.48293 12.7568 0 11.9992 0H9.00082C8.2432 0 7.57316 0.48293 7.33285 1.20164L6.95242 2.34375H3.46875C2.49945 2.34375 1.71094 3.13227 1.71094 4.10156V5.27344C1.71094 5.92609 2.29848 5.85938 2.92902 5.85938C8.34129 5.85938 13.2484 5.85938 18.7031 5.85938C19.027 5.85938 19.2891 5.5973 19.2891 5.27344V4.10156C19.2891 3.13227 18.5005 2.34375 17.5312 2.34375ZM8.18801 2.34375L8.44465 1.57242C8.52477 1.33266 8.74848 1.17188 9.00082 1.17188H11.9992C12.2515 1.17188 12.4753 1.33266 12.5548 1.57242L12.8117 2.34375H8.18801Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02612 7.10938L3.96038 18.4012C4.04335 19.3128 4.79581 20 5.71077 20H15.2895C16.2044 20 16.9569 19.3128 17.0404 18.3961L17.9742 7.10938H3.02612ZM7.57042 17.0703C7.57042 17.8427 6.39854 17.8459 6.39854 17.0703V8.86719C6.39854 8.0948 7.57042 8.09164 7.57042 8.86719V17.0703ZM11.086 17.0703C11.086 17.8427 9.91417 17.8459 9.91417 17.0703V8.86719C9.91417 8.0948 11.086 8.09164 11.086 8.86719V17.0703ZM14.6017 17.0703C14.6017 17.8427 13.4298 17.8459 13.4298 17.0703V8.86719C13.4298 8.54332 13.6919 8.28125 14.0157 8.28125C14.3396 8.28125 14.6017 8.54332 14.6017 8.86719V17.0703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcan);
export default __webpack_public_path__ + "static/media/trash-ican.d560e8926e08834daa47998b030b53c9.svg";
export { ForwardRef as ReactComponent };